<template>

    <section class="hero-wrap section pt-lg-5 pt-2">
        <div class="hero-bg" style="background-size: cover;background: url('/img/Curve Line.svg') no-repeat;"></div>
        <div class="hero-content">
            <div class="container">
                <div style="border: 1px solid rgba(255, 255, 238, 0.17)" class="rounded-lg py-5">
                    <div class="row justify-content-center">
                        <div class="col-lg-5">
                            <div class="bg-white rounded-lg shadow-lg p-4">
                                <form @submit.prevent="runForm" autocomplete="off">
                                    <div class="text-center w-75 m-auto">
                                        <h4 class="text-dark-50 text-center mt-0 font-weight-bold">Sign Up</h4>
                                        <p class="text-muted mb-3">Enter your details to register your account</p>
                                    </div>
                                    <p v-if="message"
                                       :class="['alert text-center mb-0 rounded-0 mb-3 px-3' , error ? 'alert-danger' : 'alert-success bg-primary text-white']">
                                        {{ message }}
                                    </p>
                                    <div>
                                        <div class="form-group">
                                            <label>Name</label>
                                            <input type="text" v-model="form.name"
                                                   :class="[ 'form-control' , form.errors.get('name') ? 'is-invalid' : '' ]"
                                                   placeholder="Enter your name" autocomplete="unique-1">
                                            <div v-text="form.errors.get('name')" class="invalid-feedback"/>
                                        </div>
                                        <div class="form-group">
                                            <label>Last Name</label>
                                            <input type="text" v-model="form.last_name"
                                                   :class="[ 'form-control' , form.errors.get('last_name') ? 'is-invalid' : '' ]"
                                                   placeholder="Enter your last name" autocomplete="unique-1">
                                            <div v-text="form.errors.get('last_name')" class="invalid-feedback"/>
                                        </div>
                                        <div class="form-group">
                                            <label>Phone</label>
                                            <input type="text" v-model="form.phone"
                                                   :class="[ 'form-control' , form.errors.get('phone') ? 'is-invalid' : '' ]"
                                                   placeholder="Enter your phone" autocomplete="unique-1">
                                            <div v-text="form.errors.get('phone')" class="invalid-feedback"/>
                                        </div>
                                        <div class="form-group">
                                            <label>Email address</label>
                                            <input type="text" v-model="form.email"
                                                   :class="[ 'form-control' , form.errors.get('email') ? 'is-invalid' : '' ]"
                                                   placeholder="Enter your email" autocomplete="unique-1">
                                            <div v-text="form.errors.get('email')" class="invalid-feedback"/>
                                        </div>
                                        <div class="form-group mb-3">
                                            <label>Password</label>
                                            <input type="password" v-model="form.password"
                                                   :class="[ 'form-control' , form.errors.get('password') ? 'is-invalid' : '' ]"
                                                   placeholder="Enter your password" autocomplete="unique-2">
                                            <div v-text="form.errors.get('password')" class="invalid-feedback"/>
                                        </div>
                                        <div class="form-group mb-3">
                                            <label>Confirm Password</label>
                                            <input type="password" v-model="form.password_confirmation"
                                                   :class="[ 'form-control' , form.errors.get('password_confirmation') ? 'is-invalid' : '' ]"
                                                   placeholder="Enter your password confirmation"
                                                   autocomplete="unique-2">
                                            <div v-text="form.errors.get('password_confirmation')"
                                                 class="invalid-feedback"/>
                                        </div>
                                        <div class="form-group mb-0 text-center">
                                            <button @click.prevent="loginUser"
                                                    :class="['btn btn-block btn-primary px-4' , form.loading || loading ? 'btn-loading' : '']"
                                                    type="submit">Register
                                            </button>
                                        </div>
                                        <div class="small text-black-50 mt-2">
                                            Already a customer?
                                            <router-link to="/auth/login">Sign in</router-link>
                                            instead?
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

</template>

<script>
import Form from "../../../core/forms/form";
import WelcomeInfo from "../../shared/welcome-info.vue";

export default {
    name: "dashboard",
    components: {WelcomeInfo},
    data: function () {
        return {
            loading: false,
            error: false,
            message: '',
            form: new Form({
                name: '',
                last_name: '',
                phone: '',
                email: '',
                password: '',
                password_confirmation: '',
            })
        };
    },

    methods: {
        runForm() {
            this.loginUser();
        },
        loginUser() {
            this.loading = true;
            this.error = false;
            this.message = "";
            this.form.submit('/admin/register').then((response) => {
                if (response.data.success === true) {
                    this.message = response.data.message;
                    setTimeout(function () {
                        window.location = `${window.location.origin}/`;
                    }, 2000);
                } else {
                    this.message = response.data.message;
                    this.loading = false;
                    this.error = true;
                }
            }).catch((error) => {
                this.loading = false;
            });
        }
    },

    mounted() {

    }
}
</script>

<style scoped>

</style>
